import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import {
  camera,
  cancle,
  chatcurve,
  chatcurve1,
  enterchat,
  file,
  uploadfile,
  userpatient,
} from "../Constant/Index";
import { getPhysicianchat, physicianSendmessageapi } from "../network/Network";
import { useDispatch, useSelector } from "react-redux";
import Pusher from "pusher-js";
import ChatComponent from "../Components/ChatComponent";

const PhysicianCurrentChat = () => {
 
  return (
    <>
      {/* <Footer />  */}
	  <ChatComponent  />
    </>
  );
};

export default PhysicianCurrentChat;
